import { MandatoryWarning } from 'apis/restaurant-api/merchant-admin/menu2/types';

export const mandatoryWarningsForCountry: Partial<Record<Country, MandatoryWarning[]>> = {
  ISR: [
    'with-alcohol-hard',
    'with-alcohol-soft',
    'choking-nuts',
    'choking-sausages',
    'medicine-otc',
    'with-fat',
    'with-sodium',
    'with-sugar',
  ],
};

export const mandatoryWarningTranslationMap: Record<MandatoryWarning, string> = {
  'with-alcohol-hard': 'menu.mandatoryWarnings.withAlcoholHard',
  'with-alcohol-soft': 'menu.mandatoryWarnings.withAlcoholSoft',
  'choking-nuts': 'menu.mandatoryWarnings.chokingNuts',
  'choking-sausages': 'menu.mandatoryWarnings.chokingSausages',
  'medicine-otc': 'menu.mandatoryWarnings.medicineOtc',
  'with-fat': 'menu.mandatoryWarnings.withFat',
  'with-sodium': 'menu.mandatoryWarnings.withSodium',
  'with-sugar': 'menu.mandatoryWarnings.withSugar',
};
